// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  assetId: __t.u64().primaryKey().name("asset_id"),
  creator: __t.identity(),
  kind: __t.string(),
  contentRef: __t.string().name("content_ref"),
  permCopy: __t.bool().name("perm_copy"),
  permModify: __t.bool().name("perm_modify"),
  permTransfer: __t.bool().name("perm_transfer"),
  permRemix: __t.bool().name("perm_remix"),
  permTemplate: __t.bool().name("perm_template"),
  isPremium: __t.bool().name("is_premium"),
  parentAssetId: __t.u64().name("parent_asset_id"),
  createdAt: __t.timestamp().name("created_at"),
});
